// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"c9538c22","293":"9c160c0b","389":"3c324750","589":"d661d4d5"}[chunkId] + ".chunk.js";
};